import React from 'react';
import './Receipt.scss'; // optional styling

const Receipt = ({ orderData, onClose }) => {
  const { createdOrders, message } = orderData;
  if (!createdOrders || createdOrders.length === 0) return null;

  // Combine all foods from all merchants into one list
  const allItems = createdOrders.flatMap(order => 
    order.foods.map(food => ({
      ...food,
      merchantId: order.merchantId,  // optional, for grouping
      table: order.table,
      createdAt: order.createdAt
    }))
  );

  // Sum up totals from all orders
  const totalSubtotal = createdOrders.reduce((sum, order) => sum + order.subtotal, 0);
  const totalServiceCharge = createdOrders.reduce((sum, order) => sum + order.serviceCharge, 0);
  const totalSST = createdOrders.reduce((sum, order) => sum + order.sst, 0);
  const totalGrand = createdOrders.reduce((sum, order) => sum + order.grandTotal, 0);
  const paymentMethod = createdOrders[0]?.payment; // assume same for all

  // Get table number (same across orders)
  const tableNumber = createdOrders[0]?.table?.tableno || 'N/A';

  // Format date
  const orderDate = new Date(createdOrders[0]?.createdAt).toLocaleString();

  return (
    <div className="receipt-container">
      <h2>Order Receipt</h2>
      <div className="receipt-header">
        <p><strong>Table:</strong> {tableNumber}</p>
        <p><strong>Date:</strong> {orderDate}</p>
        <p><strong>Payment:</strong> {paymentMethod}</p>
      </div>

      <div className="receipt-items">
        <div className="receipt-items-header">
          <span>Item</span>
          <span>Qty</span>
          <span>Price</span>
        </div>
        {allItems.map((item, idx) => {
          // Calculate total for this item (including addons)
          let itemTotal = item.price * item.quantity;
          const addons = [...(item.addons || []), ...(item.specialRequest || []), ...(item.extraRequest || [])];
          const addonsTotal = addons.reduce((sum, addon) => sum + (addon.addOnPrice || 0) * item.quantity, 0);
          const finalItemTotal = itemTotal + addonsTotal;

          return (
            <div key={idx} className="receipt-item">
              <div className="receipt-item-name">
                {item.title}
                {addons.length > 0 && (
                  <div className="receipt-item-addons">
                    {addons.map((addon, i) => (
                      <div key={i} className="addon">+ {addon.name}</div>
                    ))}
                  </div>
                )}
              </div>
              <div className="receipt-item-qty">{item.quantity}</div>
              <div className="receipt-item-price">RM {finalItemTotal.toFixed(2)}</div>
            </div>
          );
        })}
      </div>

      {/* <div className="receipt-totals">
        <div className="total-line">
          <span>Subtotal:</span>
          <span>RM {totalSubtotal.toFixed(2)}</span>
        </div>
        <div className="total-line">
          <span>Service Charge (10%):</span>
          <span>RM {totalServiceCharge.toFixed(2)}</span>
        </div>
        <div className="total-line">
          <span>SST (8%):</span>
          <span>RM {totalSST.toFixed(2)}</span>
        </div>
        <div className="total-line grand-total">
          <strong>Grand Total:</strong>
          <strong>RM {totalGrand.toFixed(2)}</strong>
        </div>
      </div> */}

      <div className="receipt-footer">
        <p>Thank you for your order!</p>
        <button onClick={onClose} className="close-receipt-btn">Close</button>
      </div>
    </div>
  );
};

export default Receipt;